export default "__VITE_ASSET__jKxrZqcS__"